
export class ManagerAssignModel {
    public managerId: string;
    public staffIds: string[];
}
